module.exports = "/static/assets/cb666b99d3528f91b52f985dfb102afa.svg";